import { render, staticRenderFns } from "./gHello.vue?vue&type=template&id=3bea303b&scoped=true&"
import script from "./gHello.vue?vue&type=script&lang=js&"
export * from "./gHello.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea303b",
  null
  
)

export default component.exports